/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'
import mobileBrandLogo from './commonwealth_brandstudio_mobile_logo.svg'

const BrandLogoMobile = ({ height = 32 }) => {
  return (
    <img
      alt="Commonwealth Logo"
      src={mobileBrandLogo}
      sx={{ width: 32, height }}
    />
  )
}

BrandLogoMobile.propTypes = {
  color: string,
  height: number,
}

export default BrandLogoMobile
